import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

// Minimal quick-add for use inline from a client dropdown (New Job, Estimate Builder, etc).
// Full fields (company, type, address, notes) stay on the dedicated New Client page —
// this exists so a mid-flow user isn't forced to abandon what they're doing.
export default function QuickAddClientModal({ onClose, onCreated }) {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    if (!name.trim()) { setError('Client name is required.'); return }
    setSaving(true)
    setError('')
    const { data, error } = await supabase
      .from('clients')
      .insert([{ name: name.trim(), phone: phone.trim() || null, email: email.trim() || null, client_type: 'residential', active: true }])
      .select().single()
    setSaving(false)
    if (error) { setError(error.message); return }
    onCreated(data)
  }

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <h2 style={s.title}>Add New Client</h2>
        <form onSubmit={handleSubmit}>
          {error && <div style={s.error}>{error}</div>}
          <label style={s.label}>Client Name *</label>
          <input style={s.input} value={name} onChange={e => setName(e.target.value)} autoFocus placeholder="Full name" />
          <label style={s.label}>Phone</label>
          <input style={s.input} type="tel" value={phone} onChange={e => setPhone(e.target.value)} />
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} />
          <div style={s.hint}>Company, address, and other details can be added later from the Clients page.</div>
          <div style={s.actions}>
            <button type="button" onClick={onClose} style={s.cancelBtn}>Cancel</button>
            <button type="submit" disabled={saving} style={s.saveBtn}>{saving ? 'Saving...' : 'Add Client'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}

const s = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: '16px',
  },
  modal: {
    background: 'white', borderRadius: '14px', padding: '24px',
    width: '100%', maxWidth: '420px', boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
  },
  title: { margin: '0 0 16px', fontSize: '19px', fontWeight: '700', color: '#1a2e1a' },
  label: { display: 'block', fontSize: '12px', fontWeight: '600', color: '#4a6a4a', margin: '12px 0 5px' },
  input: {
    width: '100%', padding: '11px 12px', borderRadius: '8px',
    border: '1.5px solid #d1d5db', fontSize: '15px', fontFamily: 'inherit', boxSizing: 'border-box',
  },
  hint: { fontSize: '12px', color: '#9aaf9a', marginTop: '14px', lineHeight: 1.4 },
  error: { background: '#fef2f2', color: '#dc2626', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '4px' },
  actions: { display: 'flex', gap: '10px', marginTop: '20px' },
  cancelBtn: {
    flex: 1, padding: '12px', borderRadius: '9px', border: '1.5px solid #d1d5db',
    background: 'white', color: '#374151', fontSize: '14px', fontWeight: '600', cursor: 'pointer',
  },
  saveBtn: {
    flex: 1, padding: '12px', borderRadius: '9px', border: 'none',
    background: '#2d6a2d', color: 'white', fontSize: '14px', fontWeight: '600', cursor: 'pointer',
  },
}
